var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-overlay",
            { attrs: { value: _vm.loading } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }